/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business i18next初期化。日本語/英語/ベトナム語の翻訳リソースをロードしブラウザ言語検出で自動切替
 * @graph-connects none
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultNS, resources } from './resources.js';

export { defaultNS, resources } from './resources.js';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });
